export function countryBuilderUI(countries) {
  return countries.map(country => {
    return {
      ...country
    };
  });
}

export function propertiesBuilderUI(properties) {
  return properties.map(property => {
    return {
      ...property,
      propertyListingTypeId: property.propertyStatusId,
      propertyListingTypeName: property.propertyStatusName
    };
  });
}

export function propertyDetailsBuilderUI(property) {
  return {
    ...property,
    propertyListingTypeId: property.propertyStatusId,
    propertyListingTypeName: property.propertyStatusName
  };
}
